import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { PersistGate } from 'redux-persist/integration/react';
import { ToastContainer } from 'react-toastify';
import { Provider } from 'react-redux';
import { createTheme, ThemeProvider } from '@material-ui/core/styles';
import { ptBR } from '@material-ui/core/locale';
import { HashRouter } from 'react-router-dom';
import App from './App';
import Store, { persistor } from './store/index';
import 'react-toastify/dist/ReactToastify.css';
import './fonts/Graphik-Regular.ttf';

const theme = createTheme({
  palette: {
    primary: { main: '#1976d2' },
  },
}, ptBR);

ReactDOM.render(
  <React.StrictMode>
    <Provider store={Store}>
      {/* @ts-ignore */}
      <PersistGate persistor={persistor}>
        <ThemeProvider theme={theme}>
          <HashRouter>
            <App />
          </HashRouter>
        </ThemeProvider>
        <ToastContainer />
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root'),
);
